import { colors } from 'modules/root/theme';
import React from 'react';
import BounceLoader from 'react-spinners/BounceLoader';
import styled from 'styled-components';
import useFileUpload from './useFileUpload';

const Wrappies = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-radius: 2px;
  border-color: #444444;
  border-style: dashed;
  background-color: ${colors.success.background};
  color: #444444;
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
  margin: 12px;
`;

interface DocumentUploaderProps {
  onSuccess: (image: string) => void;
}

const DocumentUploader = ({ onSuccess }: DocumentUploaderProps) => {
  const { loading, getRootProps, getInputProps, isDragActive } = useFileUpload({
    url: '/doc/upload',
    onSuccess,
  });

  return (
    <Wrappies {...getRootProps()}>
      <input {...getInputProps()} />
      {loading ? (
        <BounceLoader size={40} color="#7D4CDB" loading={true} />
      ) : isDragActive ? (
        <p>Dropp dokumentet her ...</p>
      ) : (
        <p>Dropp dokumentet her, eller klikk for å velge fil</p>
      )}
    </Wrappies>
  );
};

export default DocumentUploader;
